module.exports = __webpack_public_path__ + "images/dif-in-means-faq-04.webp";